<template>
<div class="tasks">
  <!-- adicionar tarefa rapida -->
  <div class="tasks-content elevation-1" id="dragTasks" :style="!idTaskMother ? '' : 'border: 7px solid #d4d4d4; border-radius: 5px;'">
    <div>
      <v-progress-linear :style="'margin: 4px;'" :indeterminate="!!taskLoader" :height="3" :color="taskLoader ? 'teal' : 'white'" class="mb-0"></v-progress-linear>
    </div>
    <!-- // Usado para mostrar o registr quando arrasta de outro card para esse card mostrando que ele vai vir na primeira posição (kanban) -->
    <div v-show="addTask">
      <v-layout style="padding-left: 8px; margin-left: 0px; margin-right: 0px; margin-bottom: 7px; height: 50px"  class="task-item" align-center justify-space-between row fill-height>
      <!-- <v-layout style="padding-left: 8px; margin-left: 0px; margin-right: 0px;" v-show="addTask" class="task-item" align-center justify-space-between row fill-height> -->
        <!-- // Foi usado um input normal pois o do vuetify estava muito lento -->
        <div data-v-0ab97ff2="" class="v-input v-text-field v-text-field--placeholder v-input--is-label-active v-input--is-dirty v-input--is-focused theme--light primary--text">
          <div class="v-input__control">
            <div class="v-input__slot">
              <div class="v-text-field__slot">
                <!-- // QUando está carregando muda para o outro input pois v-model.lazy o campo está sendo zerado quandorterminad de carregar -->
                <input v-if="!!taskLoader" :id="`addTaskTextField${idTaskMother}`" @keypress="saveAddValue" @blur="textFieldBlur" @keyup.enter="doneAddTask" @keyup.esc="closeAddTask" ref="addTaskTextField"  placeholder="Digite a descrição da Tarefa" maxlength="190">
                <input v-else :id="`addTaskTextField${idTaskMother}`" v-model.lazy="newTaskId_text" @blur="textFieldBlur" @keyup.enter="doneAddTask" @keyup.esc="closeAddTask" ref="addTaskTextField"  placeholder="Digite a descrição da Tarefa" maxlength="190">
              </div>
            </div>
          </div>
        </div>
        <v-btn @click="doneAddTask" :loading="loadingAddTask" fab small icon class="mx-0">
          <v-icon medium>done</v-icon>
        </v-btn>
        <v-btn @click="closeAddTask" fab small icon class="mx-0">
          <v-icon medium>close</v-icon>
        </v-btn>
      </v-layout>
    </div>
    <!-- // Coloca o delay apenas em mobile pois quando para não atrapalhar o click -->
    <draggable draggable=".task_to_drag" :delay="$vuetify.breakpoint.smAndDown ? 80 : 0" delayOnTouchOnly :disabled="dragDisabled" class="draggable" v-bind="dragOptions" v-model="taskList" @change="val => {changeStatus(val)}" group="tasks">
      <v-hover class="task_to_drag" v-for="(task, index) in taskList" :key="task.id">
        <div  slot-scope="{ hover }" class="task-item" :style="mouseCursorItem?`cursor:${mouseCursorItem};`:''" @click="activeTaskItem" :key="task.id">
          <!-- <div v-if="task['tree_task_sequence']" ><stron>{{task['tree_task_sequence']['identifier']}}</stron> - {{task['tree_task_sequence']['id_text']}}</div> -->
          <v-tooltip v-if="task['tree_task_sequence'] && showMotherTask" bottom style="overflow: hidden !important;text-overflow: ellipsis !important;display: -webkit-box;-webkit-line-clamp: 1;-webkit-box-orient: vertical;word-break: break-all;" class="task-mother-item">
            <router-link v-if="checkPermission('tasks', 'manage')" slot="activator" :to="`/task/${task['tree_task_sequence']['id']}?return=${motherEntity === 'calendar' ? 'calendar' : 'tasks'}`"><strong>{{ task['tree_task_sequence']['identifier'] }}</strong> - {{ task['tree_task_sequence']['id_text'] }}</router-link>
            <div v-else slot="activator"><strong>{{ task['tree_task_sequence']['identifier'] }}</strong> - {{ task['tree_task_sequence']['id_text'] }}</div>
            <span><p-entire-field :field="task['tree_task_sequence']['id_text']"></p-entire-field></span>
          </v-tooltip>
          <!-- Layout da Tarefa no Desktop -->
          <div class="dg-task" v-if="!isMobileDesign && !$vuetify.breakpoint.smAndDown">
            <!-- Origem da Tarefa -->
            <div class="task-origin" v-if="!task_shared && task.company_id !== $auth.user().company_id">
              <v-tooltip right>
                <v-avatar v-if="task.company.logo_path" slot="activator" size="20px">
                  <img :src="`${basePath}uploads/companies/${task.company.logo_path}`" alt="avatar">
                </v-avatar>
                <v-avatar v-else slot="activator" size="20px" class="avatar">
                  <span class="avatar-letters"> {{ getFirstLetters(((task.company_id !== $auth.user().company_id) && task.company) ? task.company.id_text : '') }} </span>
                </v-avatar>
                <span> {{ ((task.company_id !== $auth.user().company_id) && task.company) ? task.company.id_text : '' }} </span>
              </v-tooltip>
            </div>

            <div class="column" style="flex: 1">
              <div class="row" @click="editSubItem(task, 4)">
                <!-- Descrição da tarefa -->
                <div class="task-text task-text-position one-line break-all" v-resize="onResize">
                  <v-tooltip bottom>
                    <a class="" slot="activator">
                      <span class="task-id" hidden> {{ task.id }} </span>
                      <span class="commitment" hidden> {{ task.commitment }} </span>
                      <span class="team-id" hidden> {{ task.team_id }} </span>
                      <span class="subheading"><strong>{{ task.identifier_sequence }}</strong></span>
                      <span class="subheading"> - {{ task.id_text }}</span>
                    </a>
                    <p-entire-field :field="task.id_text"></p-entire-field>
                  </v-tooltip>
                </div>
              </div>
              <div class="row">
                <!-- Status, Equipe, Cliente e Urgência -->
                <p-select-status
                  :readonly="task_shared"
                  :isMobileDesign="isMobileDesign"
                  @change="val => changeStatusProcess(val, task)"
                  :status="task.status"
                  :companyId="task.company_id"
                  @statusFinalized="val => $emit('statusFinalized', val)"
                  :task_id="task.id"
                  :task="task"
                ></p-select-status>
                <!---------------- Cliente----------------->
                <!-- // O show Circle é usado por enquanto apenas nas subtarefas do gerenciamento, portanto como são subs o cliente é o mesmo da tarefa, não precisando mostrar -->
                <div v-if="task.client_id && !showCircleInfo" class="mx-1">
                  <!-- <v-tooltip bottom v-if="showCircleInfo">
                    <v-avatar v-if="task.client.auto && task.client.connection_company && task.client.connection_company.logo_path" size="25" slot="activator">
                      <img :src="`${basePath}uploads/companies/${task.client.connection_company.logo_path}`" alt="">
                    </v-avatar>
                    <v-avatar v-else-if="!task.client.auto && task.client.logo_path" size="25" slot="activator">
                      <img :src="`${basePath}uploads/connections/${task.client.logo_path}`" alt="">
                    </v-avatar>
                    <v-avatar v-else class="avatar" size="25" slot="activator">
                      <span class="avatar-letters"> {{ getFirstLetters(task.client.id_text) }} </span>
                    </v-avatar>
                    <span> {{ task.client_id ? task.client.id_text : '' }} </span>
                  </v-tooltip> -->
                  <!-- <v-tooltip bottom v-else> -->
                  <v-tooltip bottom>
                    <v-chip small disabled slot="activator" color="teal" text-color="white">
                      <v-avatar v-if="task.client.auto && task.client.connection_company && task.client.connection_company.logo_path">
                        <img :src="`${basePath}uploads/companies/${task.client.connection_company.logo_path}`" alt="avatar">
                      </v-avatar>
                      <v-avatar v-else-if="!task.client.auto && task.client.logo_path">
                        <img :src="`${basePath}uploads/connections/${task.client.logo_path}`" alt="avatar">
                      </v-avatar>
                      <v-avatar class="avatar" v-else>
                        <span class="avatar-letters"> {{ getFirstLetters(task.client.id_text) }} </span>
                      </v-avatar>
                      <span>{{task.client.id_text | formatAbbreviation(25)}}</span>
                    </v-chip>
                    <span> Cliente </span>
                  </v-tooltip>
                </div>
                <!---------------- Equipe----------------->

                <!-- // O showCircleInfo é usado por enquanto apenas nas subtarefas do gerenciamento, portanto como são subs o equié é o mesmo da tarefa, não precisando mostrar -->
                <div v-if="task.team_id && !showCircleInfo" class="mx-1">
                  <!-- <v-tooltip bottom v-if="showCircleInfo">
                    <v-avatar slot="activator" size="25" :color="task.team.color || 'primary'">
                      <span class="avatar-letters"> {{ task.team_id ? getFirstLetters(task.team.id_text) : '' }} </span>
                    </v-avatar>
                    <span> {{ task.team_id ? task.team.id_text : '' }} </span>
                  </v-tooltip> -->
                  <!-- <v-tooltip bottom v-else> -->
                  <v-tooltip bottom>
                    <v-chip small disabled text-color="white" slot="activator" :color="task.team.color ? task.team.color : ''">
                      <span>{{ (task.team_id ? task.team.id_text : '') | formatAbbreviation(25) }}</span>
                    </v-chip>
                    <span> Equipe </span>
                  </v-tooltip>
                </div>

                <!---------------- Urgencia----------------->
                <div v-if="task.urgency" class="mx-1">
                  <v-tooltip bottom v-if="showCircleInfo">
                    <v-avatar slot="activator" v-if="task.urgency" size="25" :color="translate('value.task_urgency').find((val)=>{ return val.value === task.urgency }).color">
                      {{ translate('value.task_urgency').find((val)=>{ return val.value === task.urgency }).text.charAt(0) }}
                    </v-avatar>
                    <span> {{ task.urgency ? translate('value.task_urgency').find((val)=>{ return val.value === task.urgency }).text : '' }} </span>
                  </v-tooltip>
                  <v-tooltip bottom v-else>
                    <v-chip small text-color="#222" disabled slot="activator" :color="translate('value.task_urgency').find((val)=>{ return val.value === task.urgency }).color">
                      {{ translate('value.task_urgency').find((val)=>{ return val.value === task.urgency }).text }}
                    </v-chip>
                    <span> Urgência </span>
                  </v-tooltip>
                </div>
              </div>
            </div>
            <div class="column mx-2">
              <div class="row">
              <!-- Data de Previsão -->
                <p-task-date-icon
                  :begin="task.begin"
                  :status_date="task.status_date"
                  :isMobileDesign="isMobileDesign"
                  :end="task.end"
                  :commitment="task.commitment"
                  :isFinalized="(task.status && task.status.identifier === 3)"
                ></p-task-date-icon>
                <!-- Responsável pela Tarefa -->
                <v-tooltip v-if="task.user_id" bottom>
                  <v-avatar v-if="task.user.photo_path" slot="activator" size="42px" class="mr-3">
                    <img :src="`${basePath}uploads/users/${task.user.photo_path}`" alt="Avatar">
                  </v-avatar>
                  <v-avatar v-else slot="activator" size="42px" class="avatar mr-3">
                    <span class="avatar-letters"> {{ getFirstLetters(task.user.id_text) }} </span>
                  </v-avatar>
                  <span> {{ (!task_shared && task.connection_company_id && task.connection_company_id !== $auth.user().company_id) ? (task.user.id_text + ' (' + task.connection_company.id_text + ')') : task.user.id_text }} </span>
                </v-tooltip>
                <v-tooltip v-else bottom>
                  <v-avatar slot="activator" size="42px" color="rgb(5, 231, 142)" class="avatar mr-3">
                    <v-icon size="35px" color="white">person</v-icon>
                  </v-avatar>
                  <span>Tarefa sem responsável</span>
                </v-tooltip>
              </div>
            </div>
            <div class="column" v-if="!task_shared">
              <div class="row">
                <!-- Relógio de Tempo -->
                <v-tooltip bottom>
                  <v-btn icon slot="activator" class="mx-0" @click="startDuration(task)"  :disabled="(checkIsFree() && task.company_id != $auth.user().company_id)">
                    <v-icon medium color="purple">alarm</v-icon>
                  </v-btn>
                  <span>Iniciar Tempo</span>
                </v-tooltip>
                <!-- Mais opções -->
                <v-menu
                  left
                  v-if="!hideOptions"
                  nudge-top="8"
                  content-class="elevation-0 menu_content"
                  transition="slide-x-reverse-transition"
                  :offset-x="true"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn :id="'task_more_btn'+index" v-on="on" fab small slot="activator" icon class="mx-0">
                      <v-icon large>more_vert</v-icon>
                    </v-btn>
                  </template>

                  <!-- Gerenciamento de Tarefa -->
                  <v-tooltip bottom>
                    <v-btn :id="'task_edit_btn'+index" slot="activator" small color="grey lighten-4" fab class="mx-0" @click="editSubItem(task, 4)" :disabled="!checkPermission(entity, 'manage')">
                      <v-icon color="teal">build</v-icon>
                    </v-btn>
                    <span>{{manageTooltipText}}</span>
                  </v-tooltip>

                  <!-- Deletar Tarefa -->
                  <v-tooltip bottom>
                    <v-btn :id="'task_delete_btn'+index" slot="activator" small color="grey lighten-4" fab class="mx-0" @click="deleteSubItem(task)" :disabled="!checkPermission(entity, 'delete')">
                      <v-icon color="pink">delete</v-icon>
                    </v-btn>
                    <span>{{deleteTooltipText}}</span>
                  </v-tooltip>

                  <!-- Criar Subtarefa -->
                  <v-tooltip bottom  v-if="motherEntity !== 'manageTask'">
                    <v-btn :id="'task_add_subtask_btn'+index" slot="activator" small color="grey lighten-4" fab class="mx-0" @click="createSubItem(task)" :disabled="!checkPermission(entity, 'create')">
                      <v-icon color="green">add</v-icon>
                    </v-btn>
                    <span>{{createTooltipText}} subtarefas</span>
                  </v-tooltip>

                  <!-- Duplicar Tarefa -->
                  <v-tooltip bottom>
                    <v-btn :id="'task_duplicate_btn'+index" slot="activator" small color="grey lighten-4" fab class="mx-0" @click="duplicateTask(task.id)" :disabled="!checkPermission(entity, 'create') || task.company_id !== $auth.user().company_id">
                      <v-icon color="purple">file_copy</v-icon>
                    </v-btn>
                    <span>{{checkPermission(entity, 'create') ? task.company_id !== $auth.user().company_id ? 'Não é possivel duplicar tarefa de outra Empresa' : 'Duplicar' : 'Sem permisão para duplicar'}}</span>
                  </v-tooltip>

                  <!-- realatorios de tarefa -->
                  <v-tooltip bottom>
                    <v-btn :id="'task_report_btn'+index" @click="openReportDialog(task.id, task.id_text)" slot="activator" small color="grey lighten-4" fab class="mx-0" :disabled="!checkPermission('report_task', 'view')">
                        <v-icon color="orange">library_books</v-icon>
                    </v-btn>
                    <span>{{checkPermission('report_task', 'view') ? 'Relatório' : 'Você não tem permissão para visualizar'}}</span>
                  </v-tooltip>

                  <!-- Documento Personalizado -->
                  <v-tooltip bottom v-if="task['tasktemplate_id'] && task['company_id'] === $auth.user().company_id && task['level'] == 1">
                    <v-btn small fab class="mx-0" slot="activator" @click="$emit('openDocumentPreviewList', task['id'], task['tasktemplate_id'])">
                      <v-icon color="blue">description</v-icon>
                    </v-btn>
                    <span>Documentos Personalizados</span>
                  </v-tooltip>

                  <!-- Outros Campos -->
                  <v-tooltip bottom>
                    <p-request-more-fields slot="activator" :task_id="task.id"></p-request-more-fields>
                    <span>Mais campos</span>
                  </v-tooltip>
                </v-menu>
              </div>
            </div>
            <v-flex v-if="!dontShowSubtasks" class="task-children-button" align-center>
              <p-subtask-progress :type="0" v-show="task.subtasks_clean_count > 0 || hover" @onClick="openOrExpandTask(task)" :subtasksQuantity="task.subtasks_clean_count" :task_id="task.id" :finalizedQuantity="task.finalized_subtasks"></p-subtask-progress>
            </v-flex>
          </div>

          <!-- Layout da Tarefa Mobile -->
          <div class="dg-task" v-else>
            <!-- Origem da Tarefa -->
            <div class="task-origin" v-if="!task_shared && task.company_id !== $auth.user().company_id">
              <v-tooltip right>
                <v-avatar v-if="task.company.logo_path" slot="activator" size="20px">
                  <img :src="`${basePath}uploads/companies/${task.company.logo_path}`" alt="avatar">
                </v-avatar>
                <v-avatar v-else slot="activator" size="20px" class="avatar">
                  <span class="avatar-letters"> {{ getFirstLetters(((task.company_id !== $auth.user().company_id) && task.company) ? task.company.id_text : '') }} </span>
                </v-avatar>
                <span> {{ ((task.company_id !== $auth.user().company_id) && task.company) ? task.company.id_text : '' }} </span>
              </v-tooltip>
            </div>

            <div class="column">
              <!-- Status da Tarefa -->
              <p-select-Status
                :readonly="task_shared"
                :isMobileDesign="isMobileDesign"
                @change="val => changeStatusProcess(val, task)"
                :status="task.status"
                @statusFinalized="val => $emit('statusFinalized', val)"
                :companyId="task.company_id"
                :task_id="task.id"
                :task="task"
              ></p-select-Status>
            </div>
            <div class="column" style="flex: 1;">
              <div class="row" @click="editSubItem(task, 4)">
                <!-- Descrição da tarefa -->
                <div :class="'task-text task-text-position break-all ' + this.$vuetify.breakpoint.smAndDown ? 'three-line' : 'two-line'">
                  <v-tooltip bottom>
                    <a class="" slot="activator">
                      <span class="task-id" hidden> {{ task.id }} </span>
                      <span class="commitment" hidden> {{ task.commitment }} </span>
                      <span class="team-id" hidden> {{ task.team_id }} </span>
                      <span class="subheading"><strong>{{ task.identifier_sequence }}</strong></span>
                      <span class="subheading"> - {{ task.id_text }}</span>
                    </a>
                    <p-entire-field :field="task.id_text"></p-entire-field>
                  </v-tooltip>
                </div>
              </div>
              <!-- <div class="row"> -->
                <!-- Descrição da tarefa -->
                <!-- <div class="text" style="overflow: hidden !important;text-overflow: ellipsis !important;display: -webkit-box;-webkit-line-clamp: 2;-webkit-box-orient: vertical; word-break: break-all !important; margin-top: 0px !important;" v-resize="onResize">
                  <v-tooltip bottom>
                    <router-link v-if="checkPermission('tasks', 'manage')" slot="activator" :to="`/task/${task.id}?return=${motherEntity ? motherEntity : 'tasks'}`">
                      <span class="task-id" hidden> {{ task.id }} </span>
                      <span class="team-id" hidden> {{ task.team_id }} </span>
                      <span class="commitment" hidden> {{ task.commitment }} </span>
                      <span class="body-1"><strong>{{ task.identifier_sequence }}</strong></span>
                      <span class="body-1"> - {{ task.id_text }}</span>
                    </router-link>
                    <div v-else slot="activator">
                      <span class="task-id" hidden> {{ task.id }} </span>
                      <span class="team-id" hidden> {{ task.team_id }} </span>
                      <span class="commitment" hidden> {{ task.commitment }} </span>
                      <span class="body-1"><strong>{{ task.identifier_sequence }}</strong></span>
                      <span class="body-1"> - {{ task.id_text }}</span>   
                    </div>
                    <span><p-entire-field :field="task.id_text"></p-entire-field></span>
                  </v-tooltip>
                </div> -->
              <!-- </div> -->

              <div class="row" style="justify-content: space-between">
                <div class="column-left">
                  <!-- Cliente da tarefa -->
                  <div v-if="task.client_id">
                    <v-tooltip bottom>
                      <v-avatar class="ml-1 mt-1" v-if="task.client.auto && task.client.connection_company && task.client.connection_company.logo_path" slot="activator" size="25px">
                        <img :src="`${basePath}uploads/companies/${task.client.connection_company.logo_path}`" alt="avatar">
                      </v-avatar>
                      <v-avatar class="ml-1 mt-1" v-else-if="!task.client.auto && task.client.logo_path" slot="activator" size="25px">
                        <img :src="`${basePath}uploads/connections/${task.client.logo_path}`" alt="a23vatar">
                      </v-avatar>
                      <v-avatar v-else slot="activator" size="25" class="avatar ml-1 mt-1">
                        <span class="avatar-letters"> {{ getFirstLetters(task.client.id_text) }} </span>
                      </v-avatar>
                      <span>{{task.client.id_text}}</span>
                    </v-tooltip>
                  </div>
                  <!-- Equipe da Tarefa -->
                  <div v-if="task.team_id">
                    <v-avatar class="ml-1 mt-1" slot="activator" v-if="showCircleInfo && task.team_id" size="25" :color="task.team.color || 'primary'">
                      <span class="avatar-letters"> {{ task.team_id ? getFirstLetters(task.team.id_text) : '' }} </span>
                    </v-avatar>
                  </div>
                  <!-- Urgência da Tarefa -->
                  <div v-if="task.urgency">
                    <v-avatar class="ml-1 mt-1" slot="activator" v-if="showCircleInfo && task.urgency" size="25" :color="translate('value.task_urgency').find((val)=>{ return val.value === task.urgency }).color">
                      {{ translate('value.task_urgency').find((val)=>{ return val.value === task.urgency }).text.charAt(0) }}
                    </v-avatar>
                  </div>
                </div>
                <div class="column-right">
                  <!-- Previsão da Tarefa -->
                  <p-task-date-icon
                    :begin="task.begin"
                    :status_date="task.status_date"
                    :end="task.end"
                    :isMobileDesign="isMobileDesign"
                    :commitment="task.commitment"
                    :isFinalized="(task.status && task.status.identifier === 3)"
                  ></p-task-date-icon>
                  <!-- Responsável da Tarefa -->
                  <v-tooltip v-if="task.user_id" bottom>
                    <v-avatar v-if="task.user.photo_path" slot="activator" size="26px">
                      <img :src="`${basePath}uploads/users/${task.user.photo_path}`" alt="Avatar">
                    </v-avatar>
                    <v-avatar v-else slot="activator" size="26px" class="avatar">
                      <span class="avatar-letters"> {{ getFirstLetters(task.user.id_text) }} </span>
                    </v-avatar>
                    <span> {{ (!task_shared && task.connection_company_id && task.connection_company_id !== $auth.user().company_id) ? (task.user.id_text + ' (' + task.connection_company.id_text + ')') : task.user.id_text }} </span>
                  </v-tooltip>
                  <v-tooltip v-else bottom>
                    <v-avatar slot="activator" size="26px" color="rgb(5, 231, 142)" class="avatar">
                      <v-icon size="35px" color="white">person</v-icon>
                    </v-avatar>
                    <span>Tarefa sem responsável</span>
                  </v-tooltip>
                </div>
              </div>
            </div>
            <div class="column" v-if="!task_shared">
              <v-menu
                left
                v-if="!hideOptions"
                nudge-top="8"
                content-class="elevation-0 menu_content"
                transition="slide-x-reverse-transition"
                :offset-x="true"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn fab small v-on="on" slot="activator" icon class="mx-0">
                    <v-icon large>more_vert</v-icon>
                  </v-btn>
                </template>
                <v-tooltip bottom>
                  <v-btn slot="activator" small color="grey lighten-4" fab class="mx-0" @click="startDuration(task)" :disabled="(checkIsFree() && task.company_id != $auth.user().company_id)">
                    <v-icon color="purple">alarm</v-icon>
                  </v-btn>
                  <span>Iniciar Tempo</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <v-btn slot="activator" small color="grey lighten-4" fab class="mx-0" @click="editSubItem(task, 4)" :disabled="!checkPermission(entity, 'manage')">
                    <v-icon color="teal">build</v-icon>
                  </v-btn>
                  <span>{{manageTooltipText}}</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <v-btn slot="activator" small color="grey lighten-4" fab class="mx-0" @click="deleteSubItem(task)" :disabled="!checkPermission(entity, 'delete')">
                    <v-icon color="pink">delete</v-icon>
                  </v-btn>
                  <span>{{deleteTooltipText}}</span>
                </v-tooltip>
                <!-- Documento Personalizado -->
                <v-tooltip bottom v-if="task['tasktemplate_id'] && task['company_id'] === $auth.user().company_id && task['level'] == 1">
                  <v-btn small fab class="mx-0" slot="activator" @click="$emit('openDocumentPreviewList', task['id'], task['tasktemplate_id'])">
                    <v-icon color="blue">description</v-icon>
                  </v-btn>
                  <span>Documentos Personalizados</span>
                </v-tooltip>
                <v-tooltip v-if="!hideAddSubtask && motherEntity !== 'manageTask'" bottom>
                  <v-btn slot="activator" small color="grey lighten-4" fab class="mx-0" @click="createSubItem(task)" :disabled="!checkPermission(entity, 'create')">
                    <v-icon color="green">add</v-icon>
                  </v-btn>
                  <span>{{createTooltipText}} subtarefas</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <v-btn slot="activator" small color="grey lighten-4" fab class="mx-0" @click="duplicateTask(task.id)" :disabled="!checkPermission(entity, 'create') || task.company_id !== $auth.user().company_id">
                    <v-icon color="purple">file_copy</v-icon>
                  </v-btn>
                  <span>{{checkPermission(entity, 'create') ? task.company_id !== $auth.user().company_id ? 'Não é possivel duplicar tarefa de outra Empresa' : 'Duplicar' : 'Sem permisão para duplicar'}}</span>
                </v-tooltip>
                <!-- realatorios de tarefa -->
                <v-tooltip bottom>
                  <v-btn :id="'task_report_btn'+index" @click="openReportDialog(task.id, task.id_text)" slot="activator" small color="grey lighten-4" fab class="mx-0" :disabled="!checkPermission('report_task', 'view')">
                      <v-icon color="orange">library_books</v-icon>
                  </v-btn>
                  <span>{{checkPermission('report_task', 'view') ? 'Relatório' : 'Você não tem permissão para visualizar'}}</span>
                </v-tooltip>
              </v-menu>
            </div>

            <v-flex v-if="!dontShowSubtasks" class="task-children-button" align-center>
              <p-subtask-progress v-show="task.subtasks_clean_count > 0 || hover" :type="0" @onClick="openOrExpandTask(task)" :subtasksQuantity="task.subtasks_clean_count" :task_id="task.id" :finalizedQuantity="task.finalized_subtasks"></p-subtask-progress>
            </v-flex>
          </div>
          <p-task-list @doneNewTask="(newTask) => {$emit('doneNewTask', newTask)}" ref="sublist" class="mt-2" v-if="(expanded === task.id) && !dontShowSubtasks" :dontShowSubtasks="dontShowSubtasks" @changeAllItem="changeAllItem" @sequenceExpanded="sequenceExpanded" @createSubItem="createSubItem" @duplicateTask="duplicateTask" @editSubItem="editSubItem" @deleteSubItem="deleteSubItem" @retrain="() => {expanded = null}" :allTasks="task.all_subtasks" @changeTaskList="val => task.all_subtasks = val" :idTaskMother="task.id" :taskLoader="sonLoader || taskLoader" :dragDisabled="dragDisabled" :showMotherTask="false"></p-task-list>
        </div>
      </v-hover>
      <div v-if="taskList.length === 0">
        <div v-if="!idTaskMother">
          <div v-if="!isMobileDesign && $vuetify.breakpoint.smAndUp" class="empty-tasks">
            <span class="empty-tasks-title display-1 font-weight-bold">{{!!taskLoader ? 'Procurando...' : 'Nenhuma tarefa encontrada por aqui'}}</span>
            <img class="empty-tasks-image" :src="`${basePath}images/empty_task.png`" alt="avatar">
          </div>
          <div v-else class="empty-tasks">
            <span class="empty-tasks-title title font-weight-bold">{{!!taskLoader ? 'Procurando...' : 'Nenhuma tarefa encontrada por aqui'}}</span>
            <img class="empty-tasks-image-mobile" :src="`${basePath}images/empty_task.png`" alt="avatar">
          </div>
        </div>
        <div v-else>
          <p class="text-xs-center ma-0">Nenhuma subtarefa encontrada por aqui</p>
        </div>
      </div>
      <div class="mt-3" style="cursor: pointer; border-radius:4px; background-color: teal; padding: 2px 6px; color: #fff; display: flex; align-items: center; justify-content: center" v-if="((taskList.length) < totalTasks)" @click="clickMoreTask">
        <span><strong>Mostrar mais</strong></span>
      </div>
    </draggable>
    <div v-if="(taskList.length > 0 && taskLoader)">
      <v-progress-linear indeterminate :height="3" class="mb-0"></v-progress-linear>
    </div>
  </div>
  <span v-if="pageTo && totalTasks">
    <span>{{`${this.pageTo} de ${this.totalTasks}`}}</span>
  </span>
</div>
</template>

<script>
  /* eslint-disable no-undef */
  import access from './../../mixin/access'
  import tooltip from './../../mixin/tooltip'
  import plan from '../../mixin/plan'
  import general from './../../mixin/general'
  import rules from './../../mixin/rules'
  import draggable from 'vuedraggable'
  import PRequestMoreFields from './../shared/PRequestMoreFields'
  import PTaskDateIcon from './../shared/PTaskDateIcon'
  // Tirado o pShareTask pois ele esta dentro de um speedDial não deixando ele aparecer
  // import PShareTask from './../shared/PShareTask'
  import PSelectStatus from './../shared/PSelectStatus'
  import PEntireField from './../shared/PEntireField'
  import PSubtaskProgress from './../shared/PSubtaskProgress'
  import moment from 'moment'
  import momentDurationFormatSetup from 'moment-duration-format'
  momentDurationFormatSetup(moment)

  export default {
    name: 'PTaskList',
    mixins: [access, tooltip, rules, general, plan],
    components: {draggable, PSubtaskProgress, PRequestMoreFields, PTaskDateIcon, PSelectStatus, PEntireField},
    // motherEntity usado para mostrar de onde esta o PTaskList e fazer ações epecificas como direcionar o usuário quando fecha uma tarefa, ou atividades especificas de cada tela, ou não mostrar determinados botões
    // itemDragging usado para identificar quando um registro esta sendo arratado para aquele card em specifico
    props: {
      dragDisabled: {},
      allTasks: {},
      totalTasks: {},
      statusId: {},
      hideOptions: {},
      isMobileDesign: {},
      idTaskMother: {},
      // task_shared usado quando a tarefa está compartilhada e o usuário abre a lista das subtarefas
      task_shared: {
        type: Boolean,
        default: false
      },
      // dontShowSubtasks usada quando não deve mostrar a opção para adicionar ou mostrar subtarefas
      dontShowSubtasks: {
        type: Boolean,
        default: false
      },
      // showMotherTask usada para mostrar a tarefa mãe em cima da propria tarefa
      showMotherTask: {
        type: Boolean,
        default: true
      },
      taskLoader: {},
      maxItens: {},
      // showCircleInfo usado para mostrar informações, porem em um formato menor
      showCircleInfo: {
        type: Boolean,
        default: false
      },
      motherEntity: {},
      itemDragging: {},
      mouseCursorItem: {},
      pageTo: {},
      hideAddSubtask: {}
    },
    data: () => ({
      sequenceExpandedIds: '',
      defaultItem: {},
      expanded: null,
      newTaskId_text: '',
      qtdMoreTasks: 1,
      entity: 'tasks',
      loadingAddTask: false,
      clickInsert: false,
      sonLoader: false,
      addTask: false,
      textSize: 0,
      basePath: process.env.API,
      filters: {},
      // userId usado para receber o valor do usuário logado ou nada caso o task_shared esteja true
      userId: 0,
      // companyId usado para receber o valor do usuário logado ou nada caso o task_shared esteja true
      companyId: 0
    }),
    mounted () {
      // Variavei pra armazenar o valor do tamanho do quadro para definir o tamanho do texto nas tarefas que ira mostrar para o usuário
      let doc = document.getElementById('dragTasks')
      if (doc) this.textSize = doc.offsetWidth
      // Aguarda até os registro carregarem ou até completar 10segundos para verificar se existe alguma tarefajá expandida e expande, usa o loder
      let count = 0
      let hasToExpandInterval = setInterval(() => {
        if (this.taskList.length > 0 || count >= 10) {
          count++
          clearInterval(hasToExpandInterval)
          // verificação se a task veio do back com atributo "expanded" caso sim expande os filhos dela para que o usuario já venha expandido
          let hasToExpand = this.taskList.find(item => { return item.expanded === true })
          if (hasToExpand) this.expanded = hasToExpand.id
        }
      }, 1000)
    },
    methods: {
      openReportDialog: function (taskId = '', idtext = null) {
        this.$store.commit('reportDialog/change_values', {
          showDialog: true,
          reportDialogLoading: true,
          reportDialogTasks: [{id: taskId, id_text: idtext}],
          reportDialogEditedItem: {task_id: taskId, id_text: idtext, begin: !this.checkIsFree() ? '' : moment().format('YYYY-MM-DD 00:00'), end: !this.checkIsFree() ? '' : moment().format('YYYY-MM-DD 23:59')},
          reportDialogDisable: true,
          selectedTask: false,
          disableTasks: true
        })
        if (taskId !== '') {
          this.$store.commit('reportDialog/change_values', {reportDialogLoading: false, selectedTask: true})
        } else {
          this.$http.get(`api/tasksReport`).then(res => {
            this.$store.commit('reportDialog/change_values', {
              reportDialogTasks: res.body,
              reportDialogLoading: false,
              reportDialogDisable: false
            })
          })
        }
      },
      changeStatus (val) {
        if (val.added) {
          this.$emit('changeStatus', val.added)
        } else if (val.removed) {
          this.$emit('taskRemoved', val.removed)
        }
      },
      // verificado o clickInsert se caso o usuario tiver clicado no botão de adicionar tarefa
      textFieldBlur () {
        setTimeout(() => {
          if (!this.clickInsert) this.closeAddTask()
          this.clickInsert = false
        }, 200)
      },
      // função para inserir na lista
      openAddTask (defaultItem) {
        let selectedBoard = this.$store.getters[`selectedBoard/values`]
        // Caso não seja subtarefa(pois subtarefa o usuário pode adicionar em empresas parceiras) e o usuário esteja em uma area de trabalha do outra empresa, não permite que ele adicione tarefa, pois não é possivel adicionar tarefas em outras empresa
        if (defaultItem['level'] === 1 && selectedBoard['company_id'] !== this.$auth.user().company_id) {
          this.$store.commit('snackbar/change_values', {
            text: 'Não é possível adicionar tarefas em empresas parceiras!',
            color: 'warning',
            dialog: true
          })
          return
        }
        this.$store.dispatch('selectedBoard/propertiesAddTask').then((response) => {
          // complementItem, serve pra quando terá algum item que será adicionado de complemento, no caso dos itens do board por exemplo
          // quando é subtarefa não busca os dados da do filtro (complementItem)
          let complementItem = defaultItem['level'] > 1 ? {} : JSON.parse(JSON.stringify(response['values']))
          this.addTask = true
          this.newTaskId_text = ''
          this.focusAddTask()
          // Caso já tenha status significa que veio do kanban
          if (defaultItem['task_status_id'] > 0) {
            complementItem['task_status_id'] = defaultItem['task_status_id']
          }
          this.defaultItem = Object.assign(defaultItem, complementItem)
          // se for tarefa do topo e tiver modelo vinculado, puxa os valores do modelo
          if (this.defaultItem['level'] === 1 && complementItem['tasktemplate']) {
            // tirar alguns valores que não devem ir para a tarefa
            let tasktemplate = complementItem['tasktemplate']
            delete tasktemplate.top_id
            delete tasktemplate.identifier
            delete tasktemplate.id_text
            delete tasktemplate.tasktemplate_id
            // Caso já tenha status significa que veio do kanban
            if (defaultItem['task_status_id'] > 0) delete tasktemplate['task_status_id']
            // Coloca o complementItem por ultimo pois prioriza os valores do board
            this.defaultItem = Object.assign(defaultItem, tasktemplate, complementItem)
          }
          // Caso tenha cliente coloca ele em cochetes, pois quando estava indo no adicionar rápido, o validate estava travando pois o campo cliente estar como integer normal
          if (this.defaultItem['client_id'] && !Array.isArray(this.defaultItem['client_id'])) this.defaultItem['client_id'] = [this.defaultItem['client_id']]
        }, err => {
          console.log(err)
          this.$store.commit('snackbar/change_values', {
            text: `Ocorreu um erro ao carregar os registros, reporte o erro!`,
            color: 'error',
            dialog: true
          })
          this.$store.commit('loader/change_dialog', false)
        })
      },
      openOrExpandTask (task) {
        if (this.expanded === task.id) {
          this.expanded = null
        } else {
          task.subtasks_clean_count === 0 ? this.openAddSubTask(task) : this.expandTask(task)
        }
      },
      // função para abrir adição de subtarefas ela altera o default item da filha para vir com as propriedades necessarias
      openAddSubTask (task) {
        // caso a ainda n esteja expandida a aba de subtarefas ela é expandida
        if (this.expanded !== task.id) this.expandTask(task)
        setTimeout(() => {
          // verificação do userId, caso seja uma tarefa de conexão a subtarefa inserida vem sem responsável
          let userId = this.$auth.user().company_id === task.company_id ? this.$auth.user().id : null
          this.$refs.sublist[0].openAddTask({identifier: '', user_id: userId, connection_id: null, connection_company_id: null, team_id: task.team_id, tasktemplate_id: task.tasktemplate_id, company_id: task.company_id, category_id: '', client_id: task.client_id, task_status_id: '', id_text: '', begin: '', end: '', urgency: '', note: '', task_id: task.id, top_id: task.top_id, recurrence: {type: '', id_text: {each: '', days: '', months: '', daysToCreate: 1}}, password: '', shared: false, sons: [], identifier_sequence: '', level: task.level + 1})
        }, 200)
      },
      saveAddValue () {
        this.newTaskId_text = document.getElementById(`addTaskTextField${this.idTaskMother}`).value
      },
      doneAddTask () {
        // click insert passa para true para impedir que o componente seja fechado no blur
        this.clickInsert = true
        this.loadingAddTask = true
        // coloca o loading no confirmar por 2 segundos, so pra mostrar que está salvando
        setTimeout(() => {
          this.loadingAddTask = false
        }, 2000)
        if (this.newTaskId_text !== '') {
          let newItem = this.defaultItem
          newItem.id_text = this.newTaskId_text
          this.$emit('doneNewTask', newItem)
          this.newTaskId_text = ''
          // Limpa o addTaskTextField pelo document pois limpando no newTaskId ainda não limpa quando o campo está carregando
          document.getElementById(`addTaskTextField${this.idTaskMother}`).value = ''
          this.$refs.addTaskTextField.focus()
        } else {
          this.$store.commit('snackbar/change_values', {
            text: 'Favor preencher o campo de descrição!', color: 'warning', dialog: true
          })
          this.$refs.addTaskTextField.focus()
        }
      },
      // função para fechar a parte do componente de inserção rapida
      closeAddTask () {
        this.addTask = false
        if (this.taskList.length === 0) this.$emit('retrain')
      },
      focusAddTask () {
        setTimeout(() => {
          // caso seja mobile não vem focado, para não abrir o teclado e ocupar a tela
          if (this.$refs.addTaskTextField && !this.$vuetify.breakpoint.smAndDown) this.$refs.addTaskTextField.focus()
        }, 200)
      },
      clickMoreTask () {
        this.qtdMoreTasks++
        this.$emit('clickMoreTask', this.qtdMoreTasks)
      },
      expandTask (task) {
        if (this.expanded === task.id) {
          this.expanded = null
          this.sequenceExpandedIds = null
          this.$emit('sequenceExpanded', null)
          this.closeAddTask()
        } else {
          this.$emit('sequenceExpanded', task.id)
          // serve para colocar o carregamento no determinado botão
          this.sonLoader = task.id
          this.expanded = task.id
          this.$http.get(`api/get_subtasks/${task.id}`).then(res => {
            task.all_subtasks = res.body
            // Atualiza o count das subtarefas caso seja criado alguma tarefa depois que já está carregada
            task.subtasks_clean_count = task.all_subtasks.length
            // this.taskLoader = false
            this.sonLoader = false
          })
          this.sequenceExpandedIds = task.id
          this.openAddSubTask(task)
        }
      },
      sequenceExpanded (sequence) {
        var sequenceExpandedIds = this.sequenceExpandedIds + (sequence ? `.${sequence}` : '')
        this.$emit('sequenceExpanded', sequenceExpandedIds)
      },
      createSubItem: function (item) {
        this.$emit('createSubItem', item)
      },
      duplicateTask: function (id) {
        this.$emit('duplicateTask', id)
      },
      editSubItem: function (item, view) {
        this.$emit('editSubItem', item, view)
      },
      deleteSubItem: function (item) {
        this.$emit('deleteSubItem', item)
      },
      updateDatetimeEnd: function (datetime) {
        this.editedItem.end = datetime
      },
      activeTaskItem: function (event) {
        $('.task-item').removeClass('task-item-active')
        $(event.target.closest('.task-item')).addClass('task-item-active')
      },
      changeAllItem: function (item, reloadFilter) {
        this.$emit('changeAllItem', item, reloadFilter)
      },
      onResize () {
        let doc = document.getElementById('dragTasks')
        if (doc) this.textSize = doc.offsetWidth
      },
      allowDrop (ev) {
        ev.preventDefault()
      },
      changeStatusProcess (value, item) {
        // coloca o status antigo no item para verificar se foi finalizado ou não
        item['old_status'] = item.status
        item.status = value
        item.task_status_id = value ? value.id : null
        // Caso tenha o changeUser significa que foi alterado para um status que deve altarar o responsável, portanto alterar o responsável no front
        if (item.status['changeUser']) {
          Object.assign(item, item.status['changeUser'])
        }
        // statusChanged emit usado quando edita um status da subtarefa no gerenciamento de tarefas, pois tem que editar na tela de consulta também
        this.$emit('statusChanged', item)
      },
      deleteTask (task) {
        this.$http.delete(`api/${this.entity}/${task.id}`).then(res => {
          this.$store.commit('loader/change_dialog', false)
          this.$store.commit('snackbar/change_values', {text: 'Registro de ' + this.translate('table.' + this.entity + '.title')[0] + ' excluído com sucesso!', color: 'success', dialog: true})
          this.$emit('itemDeleted', res.body)
        }, err => {
          console.log(err)
          this.$store.commit('loader/change_dialog', false)
          if (err.body.message === 'actionDenied') {
            this.$store.commit('snackbar/change_values', {text: 'Apenas os administradores da empresa, responsáveis da equipe ou o responsável da tarefa podem excluir-la.', color: 'warning', timeout: 10000, dialog: true})
          } else {
            this.$store.commit('snackbar/change_values', {text: 'Não foi possível deletar o registro de ' + this.translate('table.' + this.entity + '.title')[0] + ', reporte o erro.', color: 'error', dialog: true})
          }
        })
      },
      startDuration: function (item) {
        let values = {task_id: item.id, begin: moment().format('YYYY-MM-DD HH:mm:ss'), end: moment().format('YYYY-MM-DD HH:mm:ss'), id_text: item.id_text, active: true, httpDB: true}
        // Passado o httpDB para true para iniciar o tempo no banco
        // E depois passar no socket como false para não incluir no banco pelas outras abas
        this.$store.commit('stopWatch/change_values', values)
        this.$socket.emit('generalEvent', {
          data: Object.assign(values, {httpDB: false}),
          responseEvent: 'changeStopWatch',
          room: `user${this.$auth.user().id}`
        })
      }
    },
    computed: {
      taskList: {
        get: function () {
          return this.allTasks
        },
        set: function (newValue) {
          this.$emit('changeTaskList', newValue)
        }
      },
      dragOptions () {
        return {
          animation: 200,
          group: 'description',
          disabled: false,
          ghostClass: 'ghost'
        }
      }
    }
  }
</script>

<style scoped>
  .empty-tasks {
    display: flex;
    flex-direction: column;
    align-items: center;
    border-radius: 5px;
    padding: 10px;
    text-align: center;
  }
  .ghost {
    opacity: 0.5;
    background: #dbdddf;
  }
  .empty-tasks .empty-tasks-title{
    color: #555;
  }

  .empty-tasks .empty-tasks-image{
    width: 30%;
  }

  .empty-tasks .empty-tasks-image-mobile{
    width: 70%;
  }
  
  .empty-tasks .empty-tasks-body{
    color: #444;
  }

  .dg-buttons {
    margin-top: -8px;
  }

  .task-children-button{
    position: absolute;
    bottom: 0;
    left: 50%;
    height: 20px;
    transform: translate(-50%, 50%);
    display: flex;
  }

  .draggable {
    height: 100% !important;
  }

  .children-label{
    padding: 4px 8px;
    z-index: 2;
    border-radius: 50%;
    cursor: pointer;
  }

  .add-children-label{
    padding: 4px 8px;
    z-index: 6;
    border-radius: 50%;
    cursor: pointer;
  }

  .speed-dial {
    display:inline !important;
    /*float:right !important;*/
  }

  .avatar {
    background: linear-gradient(to right, #00F260 , #0575E6);
    color: #fff;
  }

  .avatar-letters {
    font-weight: bold;
    color: #fff;
    font-size: 1.2em;
  }

  .hide-tasks {
    display: none;
  }

  .tasks {
    display: flex;
    flex-direction: column;
    /* margin-left: 6px; */
    /* border: 2px solid #00acc2; */
    border-radius: 5px 5px 0 0;
    background-color: white;
  }

  .column-right{
    display: flex;
    text-align: center;
  }

  .tasks .tasks-content {
    height: 100%;
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    padding: 6px;
    padding-top: 0px;
    padding-left: 8px;
  }

  .tasks .tasks-content .task-item {
    position: relative;
    border: 1px solid #00acc250;
    border-radius: 5px;
    margin-top: 3px;
    margin-bottom: 7px;
    box-shadow: 0 1px 1px -1px rgba(0,0,0,.2), 0 1px 2px 0 rgba(0,0,0,.14), 0 1px 3px 0 rgba(0,0,0,.12)
  }

  .task-mother-item {
    border: 1px solid #00acc250;
    border-radius: 5px;
    padding-left: 5px;
    font-size: 11.5px;
  }

  .tasks .tasks-content .task-item-active {
    background: #b3d4fd;
  }

  .tasks .tasks-content .task-item:nth-child(1) {
    margin-top: 0;
  }

  .tasks .tasks-content .task-item:hover {
    background: #eee;
    transition: 0.5s;
  }

  .tasks .tasks-content .task-item a {
    color: #02444d;
  }

  .tasks .tasks-content .task-item:nth-child(1) {
    margin-top: 0;
  }

  .dg-task{
    display: flex;
    align-items: center;
    position: relative;
    padding-bottom: 6px;
  }

  .dg-task .task-origin{
    position: absolute;
    top: -6px;
    left: -8px;
    border-radius: 50%;
    border: 1px solid #00F260;
    background: #fff;
    color: #333;
  }

  .dg-task .column{
    display: flex;
    flex-direction: column;
  }

  .dg-task .column .row{
    display: flex;
    align-items: center;
  }

  .task-text-position {
    margin-top: 0px !important;
    margin-left: 12px!important;
  }

  .tasks .tasks-content .task-item .task-info {
    display: flex;
    width: 100%;
    justify-content: space-between;
    margin: 8px 0;
  }

  .tasks .tasks-content .task-item .task-info .urgency-client {
    display: flex;
  }

  .tasks .tasks-content .task-item .task-info .urgency-client .client {
    margin-right: 6px;
  }

  .column-left{
    display: flex;
    flex-wrap: wrap;
  }

  .select-status {
    background-color: white !important;
    border-style: solid !important;
    border-color: #00acc1 !important;
    padding-right: 8px;
    padding-left: 8px;
  }
</style>



// WEBPACK FOOTER //
// src/components/shared/PTaskList.vue